module.exports = __webpack_public_path__ + "static/media/uae-makani-data-viewer.c0691186.jpg";